module.exports = __webpack_public_path__ + "img/brand--mass.02b17898.png";